import {
  GET_INSIGHTS_SEARCH_RESULTS,
  GET_ALL_INSIGHTS_SEARCH_RESULTS,
  RESET_DATA
} from '../actions/InsightsInfo';
import {
  success
} from "./helpers";

const initialState = {
  search_results: [],
  all_search_results: []
}
export const insightsInfo = (state=initialState, action) => {
  switch (action.type) {
    case success(GET_INSIGHTS_SEARCH_RESULTS):
      let filterPayload = {
        ...action.payload
      }
      for (const list of filterPayload.insightTags.data) {
        for (const id of Object.keys(filterPayload.bizUnits)) {
          if (list.clientId === parseInt(id, 10)) {
            list['children'] = filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        search_results: filterPayload
      }
    case success(GET_ALL_INSIGHTS_SEARCH_RESULTS):
      let $filterPayload = {
        ...action.payload
      }
      for (const list of $filterPayload.insightTags.data) {
        for (const id of Object.keys($filterPayload.bizUnits)) {
          if (list.clientId === parseInt(id, 10)) {
            list['children'] = $filterPayload.bizUnits[id];
          }
        }
      }
      return {
        ...state,
        all_search_results: $filterPayload
      }
    case RESET_DATA:
      return {
        ...state,
        search_results: []
      }
    default:
      return state
  }
}

export default {
  insightsInfo
}


// WEBPACK FOOTER //
// ./src/reducers/insightsInfo.js